import BuildingIcon from '../../assets/logo/Building.svg'

const BuildingCustomIcon = () => (
  <img src={BuildingIcon} alt='logo' />
);

export default BuildingCustomIcon;